/*
 * @Author: bbqin
 * @Date: 2023-03-01 16:01:16
 * @LastEditTime: 2023-03-01 16:21:47
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\empty\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component, Fragment } from 'react';
require('./index.less');

const defaultProps = {
    prefixCls: 'empty-prompt',
    img: <i className='empty-prompt-img' />,
    emptyContent: null,
    text: '',
};

class EmptyPrompt extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            prefixCls,
            img,
            text,
            emptyContent,

        } = this.props;

        const content = <div className={`${prefixCls}-content`}>
            {img}
            <span>{text}</span>
        </div>;
        return <div className={`${prefixCls}`}>
            {typeof emptyContent === 'function' ? emptyContent() : content}
        </div>;
    }
}

EmptyPrompt.defaultProps = defaultProps;

export default EmptyPrompt;